import { Avatar, Button, Card, Tag } from "antd";
import { StaffUserType } from "utils/Types";
import { getAvatarColorsByAlpha } from "utils/Colors";
import AuthHelper from "components/auth/helpers";
import { APP_ROLES } from "utils/Constants";

import style from "./style.module.css";
import { useTranslation } from "react-i18next";
import { initialName } from "utils/Format";

interface StaffCardInterface {
  staff: StaffUserType;
  handleView: (staff: any) => void;
}
const StaffCard = (props: StaffCardInterface) => {
  const { t } = useTranslation();
  const { handleView } = props;
  const { email = "", firstName = "", lastName = "", roles = [], passwordSet } = props.staff;
  const [foregroundColor, backgroundColor] = getAvatarColorsByAlpha(firstName);
  const currentUserEmail = AuthHelper.getEmail();
  const isYou = currentUserEmail.toLowerCase() === email.toLowerCase();
  let displayedName = [firstName, lastName].join(" ").trim();
  if (isYou) {
    displayedName = displayedName + " (you)";
  }
  const isAdmin = roles.includes(APP_ROLES.ADMIN);
  const notAccepted = passwordSet === false;

  return (
    <Card style={{ borderRadius: 8 }}>
      <div className={style.container}>
        <div className={style.header}>
          <div className={style["header-inner"]}>
            <Avatar
              style={{ color: foregroundColor, backgroundColor: backgroundColor }}
              size={40}
              aria-hidden={true}
            >
              {initialName(firstName)}
            </Avatar>
            <div className={style["heading-text-container"]}>
              <h2 className={style.name}>{displayedName}</h2>
              <div className={[style.email, "text-wrap"].join(" ")}>{email}</div>
              {isAdmin && <Tag>{t("staffList.card.tagAdmin")}</Tag>}
              {notAccepted && (
                <Tag className="whitespace-wrap">{t("staffList.card.tagInvited")}</Tag>
              )}
            </div>
          </div>
        </div>
        <Button
          block
          onClick={() => handleView(props.staff)}
          aria-label={`View full profile – ${firstName} ${lastName}`}
        >
          {t("staffList.card.viewFullCTA")}
        </Button>
      </div>
    </Card>
  );
};

export default StaffCard;
